import { useQuery } from '@tanstack/react-query';

import masterServicesApi from '../../../apis/master-services';
import useLocationQuery from '../../../hooks/useQuery';

import ConsultationsTable from './ConsultationsTable';
import { DEFAULT_LIMIT } from '../constants';
import { usePersistedTotal } from '../../../hooks/useTablePagination';

export default function ConsultationsContainer() {
  const { query, changeLocationQuery } = useLocationQuery();
  const { page = 0, limit = 10 } = query;

  const { data: { data: services, pagination } = {}, isLoading } = useQuery({
    queryKey: ['master-services', query.page, query.limit || DEFAULT_LIMIT],
    queryFn: () => masterServicesApi.getServiceCatalog({ page: query.page, limit: query.limit, type: 'Consultation' }),
    meta: { errorMessage: 'Failed to load consultations'},
    refetchOnWindowFocus: false,
  });

  const total = usePersistedTotal(pagination?.total);

  return (<div>
    <ConsultationsTable
      consultations={services}
      page={Number(page)}
      rowsPerPage={Number(limit)}
      rowsPerPageOptions={[5, 10, 20, 50]}
      total={total}
      isLoading={isLoading}
      onRowsPerPageChange={(e) => changeLocationQuery({ ...query, limit: e.target.value })}
      onPageChange={(_, newPage) => changeLocationQuery({ ...query, page: newPage })}
    />
  </div>);
};
